{
  "Mon": "pondelok",
  "Tue": "utorok",
  "Wed": "streda",
  "Thu": "štvrtok",
  "Fri": "piatok",
  "Sat": "sobota",
  "Sun": "nedeľa",
  "CORE": {
    "notificationDateFormat": "d/M/yy",
    "update": "Loading...",
    "youAreOffline": "Device offline! Connect to a network and try again later!",
    "comeBack": "{{icon}} your skis are waiting for you",
    "help": "Pomoc",
    "notification": {
      "ok": "Chápem"
    },
    "skiHire": "Požičovňa lyží"
  },
  "ALPINSKIHIRE": {
    "AR": {
      "start": {
        "selectBookingParametersFact3": "Môžete platiť vo svojej mene! Alpy.com uhradí náklady za konverziu vašej meny. Sadzby sú aktualizované denne.",
        "searchHeadline": "Kde by ste si chceli požičať lyže alebo snowboard?"
      },
      "showTownReserveEarlyEnoughInfo": "Upozorňujeme, že počas sezóny môže byť v predajniach nedostatok vybavenia. Odporúčame vám, aby ste rezerváciu uskutočnili vopred.",
      "shop_filter_distance_to_center": "<strong>Vzdialenosť</strong> od centra mesta: <strong><span id='range'>{{ distance }}</span>km</strong>",
      "shopSearch": {
        "formSearchButtonLabel": "Hľadať",
        "promocode": {
          "couponCodeIsInCart": "Kód poukazu {{ code }} bol pridaný do vášho košíka a bude započítaný pri pokladni.",
          "typePromo": "Promo",
          "typeCoupon": "Poukaz"
        }
      }
    },
    "offer": {
      "title": "Prečo si zarezervovať svoje lyže cez {{ platformname }}"
    },
    "start": {
      "advantagesHeadline": "Záruka najvýhodnejších cien v požičovni lyží v prostredníctvom online rezervácie",
      "listedBrands": "Dostupné značky",
      "topTowns": "Najlepšie požičovne lyží"
    },
    "sidebar": {
      "hotlineItalic": "Chceme vám pomôcť!",
      "callNow": "Volať teraz na: ",
      "hotline": "Horúca linka"
    },
    "shopSearch": {
      "validation": {
        "selectAgeForEveryChild": "Uveďte vek každého dieťaťa (vek na začiatku výpožičného obdobia)",
        "onePersonRequired": "Vyberte aspoň jednu osobu",
        "enterTown": "Vyberte lyžiarske stredisko"
      },
      "minified": {
        "users": "Dospelé osoby ({{ number_adults }}), Deti ({{ number_children }})",
        "date": "{{ start_date }} - {{ end_date }}",
        "dateFormat": "EEEEEE d/M/yy"
      },
      "datePickerDisplayFormat": "EEEEEE d/M/yy",
      "datePickerPreviousMessage": "Vybavenie si môžete vyzdvihnúť v predajni dňa <span>{{ date }}</span> od 15:30. Nočné lyžovanie nie je do ponuky zahrnuté.",
      "datePickerPreviousMessageDateFormat": "d/M/yy",
      "formSearchLabel": "Stredisko, dedina, krajina, názov predajne",
      "formSearchInfo": "Chvíľku strpenia, vyhľadávame zhodné výsledky…",
      "formSearchResultDescription": "({{region}}, {{province}})",
      "formSearchResultShopNumber": "Predajne: {{ count }}",
      "formSearchResultShowAll": "Zobraziť všetky výsledky: {{ count }}",
      "formSearchResultGroupLocations": "Dedina",
      "formSearchResultGroupShops": "Shops",
      "formSearchResultGroupRegions": "Región",
      "formSearchResultGroupCountries": "Krajiny",
      "formSearchButtonLabelDelivery": "Od {{price}}",
      "deliverToHotel": "Chcem, aby mi bolo zariadenie doručené do môjho ubytovania – ZADARMO!",
      "formStartDate": "Dátum zapožičania",
      "formEndDate": "Dátum vrátenia",
      "formNumberOfPeople": "Počet osôb",
      "formAdultsLabel": "Dospelé osoby",
      "formPeopleCount": {
        "numberOfPeople": "{{ number_adults }} {{ pluralizeAdult }} {{ number_children }} {{ pluralizeChildren }}",
        "adultNone": "dospelých",
        "adultSingle": "dospelého",
        "adultMultiple": "dospelých",
        "childNone": "deti",
        "childSingle": "dieťa",
        "childMultiple": "deti"
      },
      "formAdultsLabelInfo": "nad 18 rokov na začiatku výpožičného obdobia",
      "formChildrenLabel": "Deti",
      "formChildrenLabelInfo": "do 18 rokov na začiatku výpožičného obdobia",
      "formChildInputLabelInfo": "do 18 rokov na začiatku výpožičného obdobia",
      "formChildInputPlaceholder": "Koľko rokov?",
      "formPromotionCode": "Promo kód",
      "formPromotionCodeNotFound": "Tento promo kód neexistuje.",
      "noResults": "Neboli nájdené žiadne výsledky"
    },
    "trustpilot": {
      "dateformat": "d/M/yyyy",
      "score": "TrustScore",
      "reviews": "recenzie",
      "reviewsOn": "recenzie na"
    },
    "navigation": {
      "skihire": "Požičovňa lyží",
      "skischool": "Lyžiarske školy",
      "accommodation": "Ubytovanie",
      "aboutUs": "O nás",
      "helpCenter": "Centrum pomoci",
      "subnavBooking": "Rezervácia",
      "subnavAdditionalOffers": "Dodatočné ponuky",
      "subnavGroupBooking": "Skupinové rezervácie",
      "subnavTermsAndConditions": "Zmluvné podmienky",
      "subnavBecomePartner": "Staňte sa partnerom",
      "subnavPrivacyPolicy": "Zásady ochrany osobných údajov",
      "subnavHelp": "Kontakt",
      "myAlpinresorts": "Môj Alpy.com",
      "subnavLogin": "Prihlásiť",
      "subnavLogout": "Logout",
      "subnavBookingsAndCancellations": "Objednávky a storná",
      "subnavPersonalSettings": "Osobné nastavenia",
      "career": "Kariéra",
      "blog": "Blog"
    },
    "geoIp": {
      "chooseACountry": "Vyberte si krajinu"
    },
    "topCountries": "Najlepšie krajiny"
  },
  "ALPINSTATIC": {
    "aboutUs": {
      "title": "O nás",
      "metaDescription": "Tu nájdete všetky informácie o tíme {{ productName }}. Zverte sa do opatery najväčšej siete požičovní lyží a lyžiarskych škôl v Európe!"
    },
    "imprint": {
      "title": "Právne informácie spoločnosti {{ productName }}",
      "metaDescription": "Imprint spoločnosti {{ productName }}"
    },
    "privacy": {
      "title": "Zásady ochrany súkromia spoločnosti {{ productName }}",
      "metaDescription": "Zásady ochrany súkromia spoločnosti {{ productName }}"
    },
    "termsAndConditions": {
      "title": "Všeobecné zmluvné podmienky | {{ productName }}",
      "metaDescription": "Všeobecné obchodné podmienky spoločnosti {{ productName }}"
    },
    "additionalOffers": {
      "title": "Dodatočné ponuky"
    }
  },
  "ROUTES": {
    "CHECKOUT": {
      "PAYMENT": "payment",
      "CHECKOUT": "checkout"
    },
    "CANCELLATION": "storno-rezervacie",
    "SKIHIREENTRY": "pozicovna-lyzi",
    "COUNTRIES": "krajiny",
    "PRODUCTS": "products",
    "PRODUCT": {
      "FINISH": "finish"
    },
    "SKIHIRE": {
      "GROUPS": "groups",
      "PRODUCTS": "products",
      "SEARCH": "vyhladavat"
    },
    "SKISCHOOLENTRY": "lyziarska-skola",
    "STATIC": {
      "SWISSPASS": "swisspass",
      "IMPRINT": "imprint",
      "PRIVACYPOLICY": "zasady-ochrany-osobnych-udajov",
      "TERMSANDCONDITIONS": "podmienky",
      "HELP": "pomoc",
      "ABOUTUS": "o-nas",
      "ADDITIONALOFFERS": "dodatocne-ponuky",
      "HOWTO": "ako-na-to"
    }
  }
}